import React from 'react';
import { useSelector } from 'react-redux';
import { Group, Typography } from '@qred/components-library';
import { formatAmount } from '~/helpers/formatters.helper';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store/types/sharedTypes';
import { useOnboardingOfferSelectors } from '~/store/selectors/onboardingOffer.selector';
import { DetailsContainer, SliderFooter } from './LoanOfferAdjustment.styled';

const PaymentDetails = () => {
  const translate = useTranslate();

  const {
    onboardingOffer: { form, overview },
    matchedMedia,
  } = useSelector((state: RootState) => state);

  const {
    monthlyAmortization,
    monthlyFee,
    monthlyPayment,
  } = useOnboardingOfferSelectors();

  return (
    <>
      <DetailsContainer>
        <SliderFooter>
          {overview.currentLoanAmountLeft > 0 &&
            form.amount !== overview.currentLoanAmountLeft &&
            translate('ApplicationCard.TotalAmountExplanation', {
              existingAmount: (
                <Typography
                  size={matchedMedia.smallScreenPortrait ? 'lg' : 'md'}
                  weight={600}
                  color="textDark.200"
                >
                  {formatAmount(overview.currentLoanAmountLeft)}
                </Typography>
              ),
              totalAmount: (
                <Typography
                  size={matchedMedia.smallScreenPortrait ? 'lg' : 'md'}
                  weight={600}
                  color="textDark.200"
                >
                  {formatAmount(form.amount)}
                </Typography>
              ),
            })}
        </SliderFooter>
        <Group justify="space-between">
          <Typography lineHeight="lg" color="textDark.200">
            {translate('MonthlyFee')}
          </Typography>
          <Typography lineHeight="lg" weight={600}>
            {formatAmount(monthlyFee)}
          </Typography>
        </Group>
        <Group justify="space-between">
          <Typography lineHeight="lg" color="textDark.200">
            {translate('MonthlyAmortization')}
          </Typography>
          <Typography lineHeight="lg" weight={600}>
            {formatAmount(monthlyAmortization)}
          </Typography>
        </Group>
      </DetailsContainer>

      <Group justify="space-between" mt="md" mb="md">
        <Typography color="information.700" lineHeight={'lg'} weight={600}>
          {translate('OnboardingOffer.TotalPerMonth')}
        </Typography>
        <Typography color="information.700" lineHeight={'lg'} weight={600}>
          {formatAmount(monthlyPayment)}
        </Typography>
      </Group>
    </>
  );
};

export default PaymentDetails;
